import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Layout from "../PageLayout/LoginLayout";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { resetPassword } from "../services/auth.service";

export default function CreateNewPassword() {
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token") || ""; // treat as code if present
  const email = searchParams.get("email") || "";

  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    if (e && typeof e.preventDefault === "function") e.preventDefault();
    setError("");

    if (!token || !email) {
      setError("Reset link is invalid or missing information.");
      return;
    }
    if (!password) {
      setError("Password is required.");
      return;
    }
    try {
      await resetPassword(email, token, password);
      navigate("/password-success");
    } catch (err) {
      const msg = err?.response?.data?.message || err.message || "Failed to reset password.";
      setError(msg);
    }
  };

  return (
    <Layout>
      <div className="flex min-h-screen items-center justify-center px-4">
        <div className="w-full max-w-md mx-auto">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="mb-4 inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-800"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="h-4 w-4">
              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 111.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" transform="scale(-1,1) translate(-20,0)" />
            </svg>
            Back
          </button>
          <h2 className="text-2xl font-semibold mb-2 text-start">Create New Password</h2>
          <p className="text-gray-500 text-start mb-6">
            Reset password for <span className="font-medium">{email || "your account"}</span>
          </p>

          {error && <p className="text-red-500 text-sm mb-3 text-center">{error}</p>}

          <form onSubmit={handleSubmit}>
            <div className="mb-4 relative">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="New password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-gray-300 rounded-md py-2 px-3 pr-10"
              />
              <button
                type="button"
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"
                onClick={() => setShowPassword((v) => !v)}
                tabIndex={-1}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>

            <div className="flex items-center mb-6 text-xs text-gray-500"></div>

            <button
              type="submit"
              className="w-full bg-[#1E1E2F] text-white rounded-md py-3 text-base font-medium hover:bg-gray-800 mb-2"
            >
              Continue
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
}
